import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation, inject, ChangeDetectionStrategy } from '@angular/core';
import { BankAccount, BankAccountForm, BankAccountTypeEnum, BankConnection, BankConnectionService, User } from 'taxtank-core';
import { BaseFormComponent } from '@shared/component/base/base-form.component';

/**
 * Form component which create a single manual (not basiq) bank account
 */
@Component({
  selector: 'app-bank-account-manual-form',
  templateUrl: './bank-account-manual-form.component.html',
  styleUrls: ['./bank-account-manual-form.component.scss'],
  // custom styles for properties and loan forms
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BankAccountManualFormComponent extends BaseFormComponent implements OnInit {
  @Input() bankAccount: BankAccount;
  @Output() submitted: EventEmitter<BankAccount[]> = new EventEmitter();
  @Output() back: EventEmitter<void> = new EventEmitter();
  @Output() connectionSaved: EventEmitter<BankConnection> = new EventEmitter<BankConnection>();
  form: BankAccountForm;
  bankAccountTypes = BankAccountTypeEnum;
  user: User;

  private bankConnectionService = inject(BankConnectionService);

  ngOnInit(): void {
    this.user = this.userService.getCacheFirst();
    super.ngOnInit();
  }

  buildForm(): void {
    this.form = new BankAccountForm(this.bankAccount);
  }

  save(bankAccount: BankAccount): void {
    if (this.bankAccount.bankConnection.id) {
      this.submitted.emit([bankAccount]);
    } else {
      // if user selected a new bank connection we have to save it first to get its id
      this.bankConnectionService.post(this.bankAccount.bankConnection).subscribe(((connection: BankConnection) => {
        bankAccount.bankConnection = connection;
        this.submitted.emit([bankAccount]);
        this.connectionSaved.emit(connection);
      }));
    }
  }
}
